import { createSvgIcon } from '../create-svg-icon';

export const EonNetIcon = () => {
    return (
        <>
            <img src="https://drive.eonnet.uk/images/eonnet.png" alt='' width={20} height={20} />
        </>
    )
}
